/* global webpack */

import { toUrl } from '../utils/security'
import { isText } from '../utils/bits'
import { signUserFunction } from './gallery-properties.flow'

import envRaw from '../utils/env-raw'

export default signUserFunction(calcVoteFramePath)

function calcVoteFramePath(rawVal, calcProp) {
  // If a user enables "allow_voting" option on Gallery Edit Page and tries to vote for some item,
  // the server returns an error, because Gallery Edit Page does not sync changes with the server in real time.
  // This server's response causes gallery to disable "allow_voting" and hide all vote frames,
  // which looks like a bug for a user, who does not know anything about all of these.
  //
  // So, in order to avoid such confusion for users, I decided to use mock version of vote-frame when a gallery is in "live-edit" mode.
  // This allows users to see how voting and authorization work even if the server does not allow such actions for user's gallery yet

  const key = calcProp('key')
  const use_mock_vote_frame = calcProp('use_mock_vote_frame')

  if (isText(rawVal)) {
    return rawVal
  } else if (use_mock_vote_frame) {
    const base = `${webpack.galleryAssetHost}/webpack/vote-frame/mock.html?id=${key}`
    const optional = envRaw.showsVoteFrameDebug ? '&debug-vote-frame=true' : ''
    return toUrl(base + optional)
  } else {
    const base = `${webpack.apiServerHost}/gallery-vote-frame/${key}`
    const optional = envRaw.showsVoteFrameDebug ? '?debug-vote-frame=true' : ''
    return toUrl(base + optional)
  }
}
